'use strict';

import React, { Component } from 'react';

import styles from './assets/indexResponse.module.css';

const print = function (value) { };
class DDS_lanhupage_Footer extends Component {
  state = {};
  setValue(val) { }

  returnTop = () => {
    if (document.getElementById('mainwrap')) {
      document.getElementById('mainwrap').scrollTo({
        top: 0, // 垂直滚动500px
        left: 0, // 水平位置（这里不改变）
        behavior: 'smooth' // 平滑滚动效果
      });
    } else {
      window.scrollTo({
        top: 0, // 垂直滚动500px
        left: 0, // 水平位置（这里不改变）
        behavior: 'smooth' // 平滑滚动效果
      });
    }

  }
  render() {
    return (
      <div className={`${styles['section_5']} flex-col indexResponse_section_5__1POZ-`} id="footer">
        <div className={`${styles['group_10']} flex-row indexResponse_group_10__23AtB indexResponse_group_10__1BSwP`}>
          <img
            className={`${styles['image_4']} clickable `}
            onClick={() => this.returnTop()}
            src={
              require('./assets/img/SketchPng0e68dd3406b3f0556c1e31a159c117b7cb297c0afa5441eb14f084a3332e0740.png')
            }
          />
          <div className={`${styles['box_21']} flex-col heightAuto`}>
            <div className={`${styles['text-group_25']} flex-col indexResponse_text-group_25__1avoi heightAuto`}>
              <span className={`${styles['text_25']}`}>联系我们</span>
              <span className={`${styles['text_26']}`}>电话：010-57528293 &nbsp; 邮箱：gxjjzwh@163.com </span>
              <span className={`${styles['text_26']}`}>合作：陈老师(13311331875 微信同号)、李老师(13911417520 微信同号)</span>
            </div>
            {/* <span className={`${styles['text_27']} widthAuto`}>
              友情链接：<a href='http://www.elitab.top/' className='link_to'>励英教育</a>
            </span> */}
            <div className='flex-row visible'>
              <span className={`${styles['text_28']} visible widthAuto`}>地址：</span>
              <span className={`${styles['text_28']} visible`}>
                北京市海淀区学院南路12号北京师范大学京师科技大厦A座616室<br />
                中国成协高校继续教育发展专委会[100082]
              </span>
            </div>
          </div>
          <div className={`${styles['box_22']} flex-col indexResponse_box_22__2TYX9 widthAuto`}>
            <span className={`${styles['text_29']}`}>加入我们</span>
            <span className={`${styles['text_28']} widthAuto`}>曹老师(华南地区) : 13875827505微信同号、王老师(华北地区) : 17600515666微信同号</span>
            <span className={`${styles['text_28']} widthAuto`}>曾老师(西南地区) : 18628071022微信同号、袁老师(东北地区) : 13304058565微信同号</span>
            <span className={`${styles['text_28']} widthAuto`}>李老师(西北地区) : 13891945215微信同号、谢老师(华东地区) : 13816941866微信同号</span>
          </div>
          <div className={`${styles['box_22']} flex-col indexResponse_box_22__2TYX9`}>
            <span className={`${styles['text_29']}`}>关注我们</span>
            <div className={`${styles['image-text_37']} flex-col align-center`}>
              <div className={`${styles['section_6']} flex-col indexResponse_section_6__3KxcQ`} >
                <img src={
                  require('./assets/img/gonzonghao.png')
                } />
              </div>
              <span className={`${styles['text-group_13']}`}>微信号</span>
            </div>
          </div>

        </div>

        {/* <img
          className={`${styles['image_5']}`}
          src={
            require('./assets/img/SketchPngd7b4ab36e5342a6b5578205c5aa31ac227c9ae9eec1377f71b45b7fb3b0bfc37.png')
          }
        /> */}
        <span className={`${styles['text_30']} indexResponse_text_30__1GEkt visible`}>指导单位：中国成人教育协会 高等院校继续教育发展专业委员会</span>
        <span className={`${styles['text_30']} indexResponse_text_30__1GEkt visible`} style={{ marginTop: "-1vw" }}>版权所有©北京盈迦国际教育咨询有限公司 京ICP备2025116631号-2</span>
        <div className={`${styles['box_12']} flex-col indexResponse_box_12__29QMj`}>
          <div className={`${styles['block_9']} flex-col indexResponse_block_9__21K3g`}>
            <div className={`${styles['box_13']} flex-col`} />
          </div>

        </div>
      </div>
    );
  }
}
export default DDS_lanhupage_Footer;
